import "./css/StaticPages.css";
import logo from "../images/svg/sidebar-logo.svg";

export default function TermsOfService() {
  return (
      <div className="min-h-screen bg-gray-50 px-4 py-8">
    
        <div className="static-page-wrapper">
  
          <div className="static-page-logo">
            <img src={logo} alt="DidYouSign" />
          </div>
  
          <div className="text-center static-page-header">
            <h1 className="static-page-title">
              Terms of Service
            </h1>
  
            <p className="static-page-effective-date">
              Effective Date: August 20, 2026
            </p>
          </div>
  
          <div className="static-page-document static-page-content">

          <section>
            <p>
              These Terms of Service (<strong>“Terms”</strong>) govern your
              access to and use of DidYouSign, including our website,
              applications, electronic signature tools, waiver services,
              messaging features, and related services (collectively, the
              <strong>“Service”</strong>).
            </p>

            <p>
              By accessing or using DidYouSign, you agree to these Terms. If
              you do not agree, do not use the Service.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              1. About DidYouSign
            </h2>

            <p>
              DidYouSign provides tools that allow businesses, organizations,
              and individuals to create, send, manage, and electronically sign
              documents, waivers, agreements, and related records.
            </p>

            <p>
              DidYouSign provides technology for facilitating these
              transactions. <strong>We are not a law firm and do not provide
              legal advice.</strong> You are responsible for determining
              whether your documents, agreements, disclosures, and use of
              electronic signatures comply with applicable laws.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              2. Eligibility and Accounts
            </h2>

            <p>
              You must be legally capable of entering into a binding agreement
              to use the Service.
            </p>

            <p>
              If you create an account, you are responsible for maintaining
              the confidentiality of your login credentials and for all
              activity occurring through your account. You agree to provide
              accurate information and to keep your account information
              current.
            </p>

            <p>
              If you use DidYouSign on behalf of a business or organization,
              you represent that you have authority to bind that organization
              to these Terms.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              3. Electronic Signatures and Records
            </h2>

            <p>
              DidYouSign allows documents and waivers to be completed and
              signed electronically.
            </p>

            <p>
              By using the Service to electronically sign a document, you
              consent to the use of electronic records and electronic
              signatures for that transaction.
            </p>

            <p>
              You are responsible for reviewing any document before signing
              it. DidYouSign does not determine the legality, enforceability,
              accuracy, or appropriateness of documents created or uploaded by
              users.
            </p>

            <p>
              The party sending a document is responsible for determining
              whether electronic signatures are legally appropriate for that
              document or transaction.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              4. User Content and Documents
            </h2>

            <p>
              You retain ownership of documents, information, and other
              content you submit to DidYouSign.
            </p>

            <p>
              You grant DidYouSign the limited rights necessary to host,
              process, transmit, store, and display that content solely as
              needed to operate and provide the Service.
            </p>

            <p>
              You are responsible for ensuring that you have the necessary
              rights and permissions to upload, send, collect, or process
              information through the Service.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              5. Acceptable Use
            </h2>

            <p>You may not use DidYouSign:</p>

            <ul className="static-page-list">
              <li>
                For unlawful, fraudulent, deceptive, or abusive purposes.
              </li>

              <li>
                To impersonate another person or misrepresent your identity
                or authority.
              </li>

              <li>
                To send unsolicited or unauthorized communications.
              </li>

              <li>
                To upload malware, malicious code, or content intended to
                disrupt the Service.
              </li>

              <li>
                To violate another person's intellectual property, privacy,
                or other legal rights.
              </li>

              <li>
                To obtain signatures or consent through fraud, coercion, or
                misrepresentation.
              </li>

              <li>
                In any manner that violates applicable laws or regulations.
              </li>
            </ul>

            <p>
              We may suspend or terminate access when we reasonably believe
              the Service is being misused.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              6. SMS Messaging Terms
            </h2>

            <p>
              DidYouSign may allow users or document recipients to request
              transactional SMS messages related to an electronic document,
              waiver, or signature request.
            </p>

            <p>
              Messages may include a secure link to access or sign a document,
              reminders relating to an incomplete document, confirmation of
              completion, or other information directly related to the
              requested transaction.
            </p>

            <h3 className="static-page-subheading">
              Consent
            </h3>

            <p>
              SMS messages are sent only after the recipient provides a mobile
              number and consents to receive text messages associated with the
              applicable DidYouSign transaction.
            </p>

            <p>
              Consent to receive SMS messages is not consent to receive
              marketing messages. <strong>DidYouSign does not use this
              messaging program to send promotional or advertising
              messages.</strong>
            </p>

            <h3 className="static-page-subheading">
              Message Frequency
            </h3>

            <p>
              Message frequency varies based on user activity and requests.
              Recipients generally receive messages only in connection with
              documents or transactions they initiate or have agreed to
              receive.
            </p>

            <h3 className="static-page-subheading">
              Message and Data Rates
            </h3>

            <p>
              <strong>Message and data rates may apply.</strong> Your wireless
              carrier's standard messaging and data charges may apply to
              messages sent to or received from DidYouSign.
            </p>

            <h3 className="static-page-subheading">
              Opting Out
            </h3>

            <p>
              Reply <strong>STOP</strong> to any DidYouSign text message to
              stop receiving SMS messages from that number.
            </p>

            <p>
              After submitting an opt-out request, you may receive a
              confirmation message. No additional messages will be sent unless
              you initiate or consent to a new messaging interaction where
              permitted by applicable rules.
            </p>

            <h3 className="static-page-subheading">
              Help
            </h3>

            <p>
              Reply <strong>HELP</strong> for assistance. You may also contact
              DidYouSign at{" "}
              <a
                href="mailto:didyousigntx@gmail.com"
                className="static-page-link"
              >
                didyousigntx@gmail.com
              </a>{" "}
              for customer support.
            </p>

            <h3 className="static-page-subheading">
              Carrier Disclaimer
            </h3>

            <p>
              Wireless carriers are not liable for delayed or undelivered
              messages.
            </p>

            <p>
              Your use of SMS messaging is also subject to the terms and
              policies of your wireless carrier.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              7. Fees and Payments
            </h2>

            <p>
              Certain DidYouSign features may require payment or a
              subscription.
            </p>

            <p>
              Prices, billing periods, usage limits, and included features
              will be disclosed before purchase. By purchasing a paid service,
              you authorize us or our payment processor to charge the
              applicable fees and taxes.
            </p>

            <p>
              Unless otherwise stated at the time of purchase, subscription
              fees may automatically renew until canceled.
            </p>

            <p>
              We may modify pricing or available plans prospectively with
              appropriate notice when required.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              8. Third-Party Services
            </h2>

            <p>
              DidYouSign may rely on or integrate with third-party services,
              including payment processors, telecommunications providers,
              hosting providers, authentication services, and other technology
              platforms.
            </p>

            <p>
              We are not responsible for outages, interruptions, actions, or
              services provided by third parties outside our reasonable
              control.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              9. Intellectual Property
            </h2>

            <p>
              DidYouSign and its associated software, design, branding,
              trademarks, logos, interfaces, and other proprietary materials
              are owned by DidYouSign or its licensors and are protected by
              applicable intellectual property laws.
            </p>

            <p>
              Except as expressly permitted through the Service, you may not
              copy, modify, distribute, sell, license, reverse engineer, or
              create derivative works from our proprietary materials.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              10. Privacy
            </h2>

            <p>
              Your use of DidYouSign is also governed by our Privacy Policy,
              which explains how we collect, use, protect, and disclose
              information.
            </p>

            <p>
              Our Privacy Policy is available at:
            </p>

            <p>
              <a
                href="/privacy"
                className="static-page-link"
              >
                didyousign.com/privacy
              </a>
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              11. Service Availability
            </h2>

            <p>
              We work to provide a reliable Service, but we do not guarantee
              that DidYouSign will always be available, uninterrupted, secure,
              or error-free.
            </p>

            <p>
              We may modify, update, suspend, or discontinue portions of the
              Service when reasonably necessary for maintenance, security,
              legal compliance, product improvements, or other operational
              reasons.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              12. Disclaimer of Warranties
            </h2>

            <p>
              <strong>
                To the maximum extent permitted by law, DidYouSign is provided
                on an “as is” and “as available” basis without warranties of
                any kind, whether express or implied.
              </strong>
            </p>

            <p>
              We do not guarantee that any document created, sent, stored, or
              signed using DidYouSign will be legally enforceable or
              appropriate for a particular purpose.
            </p>

            <p>
              You are responsible for obtaining legal advice when necessary.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              13. Limitation of Liability
            </h2>

            <p>
              To the maximum extent permitted by applicable law, DidYouSign
              and its owners, affiliates, employees, contractors, and service
              providers will not be liable for indirect, incidental, special,
              consequential, exemplary, or punitive damages arising from or
              related to your use of the Service.
            </p>

            <p>
              To the maximum extent permitted by law, our aggregate liability
              for claims arising from the Service will not exceed the amount
              you paid to DidYouSign during the 12 months immediately preceding
              the event giving rise to the claim.
            </p>

            <p>
              Some jurisdictions do not allow certain limitations of liability,
              so portions of this section may not apply to you.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              14. Indemnification
            </h2>

            <p>
              You agree to indemnify and hold harmless DidYouSign and its
              owners, affiliates, employees, and service providers from claims,
              damages, liabilities, losses, and expenses arising from your
              misuse of the Service, your documents or content, your violation
              of these Terms, or your violation of another person's rights.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              15. Suspension and Termination
            </h2>

            <p>
              You may stop using DidYouSign at any time.
            </p>

            <p>
              We may suspend or terminate your access if you violate these
              Terms, misuse the Service, create security or legal risk, fail to
              pay applicable fees, or engage in activity that could harm
              DidYouSign, our users, or third parties.
            </p>

            <p>
              Provisions that by their nature should survive termination will
              remain in effect.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              16. Changes to These Terms
            </h2>

            <p>
              We may update these Terms periodically to reflect changes to the
              Service, applicable laws, or our business practices.
            </p>

            <p>
              When material changes are made, we will update the effective date
              above and provide additional notice when required by law.
            </p>

            <p>
              Your continued use of DidYouSign after revised Terms become
              effective constitutes acceptance of the revised Terms.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              17. Governing Law
            </h2>

            <p>
              These Terms are governed by the laws of the{" "}
              <strong>State of Texas</strong>, without regard to
              conflict-of-law principles.
            </p>

            <p>
              Any disputes will be resolved in the courts located in{" "}
              <strong>Harris County, Texas</strong>, unless applicable law
              requires otherwise.
            </p>
          </section>


          <section>
            <h2 className="static-page-heading">
              18. Contact Us
            </h2>

            <p>
              For questions about these Terms or the DidYouSign Service,
              contact:
            </p>

            <p>
              <strong>DidYouSign</strong>
              <br />
              <a
                href="mailto:didyousigntx@gmail.com"
                className="static-page-link"
              >
                didyousigntx@gmail.com
              </a>
            </p>
          </section>

        </div>

        <footer className="static-page-footer">
          © {new Date().getFullYear()} DidYouSign. All rights reserved.
        </footer>

      </div>
    </div>
  );
}